import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from '../../Footer.styles';

var primaryLinks = function primaryLinks(links, type) {
  return links.map(function (_ref) {
    var text = _ref.text,
        href = _ref.href,
        dataTest = _ref.dataTest;
    // Avoid duplicate data-test names
    var dataTestConcat = type ? "".concat(dataTest, "-").concat(type) : dataTest;
    var displayList = text && href ? /*#__PURE__*/React.createElement("li", {
      key: text
    }, /*#__PURE__*/React.createElement(Styled.PrimaryLink, {
      href: href,
      "data-test": dataTestConcat
    }, text)) : null;
    return displayList;
  });
};

var Navigation = function Navigation(_ref2) {
  var navigation = _ref2.navigation;
  return /*#__PURE__*/React.createElement(Styled.Primary, null, /*#__PURE__*/React.createElement("div", {
    className: "container container--row"
  }, /*#__PURE__*/React.createElement(Styled.PrimaryMobileWrapper, {
    className: "xs-12-none sm-hidden"
  }, navigation.map(function (_ref3) {
    var id = _ref3.id,
        title = _ref3.title,
        links = _ref3.links,
        subSection = _ref3.subSection;
    return /*#__PURE__*/React.createElement("div", {
      key: id,
      className: "xs-12"
    }, /*#__PURE__*/React.createElement(Styled.SectionToggle, {
      id: id,
      type: "checkbox"
    }), /*#__PURE__*/React.createElement(Styled.AccordionTitle, {
      htmlFor: id
    }, title, /*#__PURE__*/React.createElement(Styled.Arrow, {
      dir: "down"
    })), /*#__PURE__*/React.createElement(Styled.SectionContent, null, /*#__PURE__*/React.createElement("ul", null, primaryLinks(links, 'mobile'))), subSection && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Styled.SectionToggle, {
      id: subSection.id,
      type: "checkbox"
    }), /*#__PURE__*/React.createElement(Styled.AccordionTitle, {
      htmlFor: subSection.id
    }, subSection.title, /*#__PURE__*/React.createElement(Styled.Arrow, {
      dir: "down"
    })), /*#__PURE__*/React.createElement(Styled.SectionContent, null, /*#__PURE__*/React.createElement("ul", null, primaryLinks(subSection.links, 'mobile')))));
  })), /*#__PURE__*/React.createElement("div", {
    className: "xs-hidden sm-block sm-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "sm-row sm-12--negative"
  }, navigation.map(function (_ref4) {
    var id = _ref4.id,
        title = _ref4.title,
        links = _ref4.links,
        subSection = _ref4.subSection;
    return /*#__PURE__*/React.createElement("div", {
      key: id,
      className: "sm-6 md-3"
    }, /*#__PURE__*/React.createElement(Styled.PrimaryTitle, null, title), /*#__PURE__*/React.createElement("ul", null, primaryLinks(links, 'desktop')), subSection && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Styled.PrimaryTitle, null, subSection.title), /*#__PURE__*/React.createElement("ul", null, primaryLinks(subSection.links, 'desktop'))));
  })))));
};

Navigation.propTypes = {
  navigation: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    links: PropTypes.array.isRequired,
    subSection: PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      links: PropTypes.array.isRequired
    })
  })).isRequired
};
export default Navigation;